/** @jsx jsx */
// External libraries
import { jsx } from '@emotion/core';

// Internal modules
import { getContent } from '@/lib';
import { Alert } from '../../Common';
import { ALERT_TYPE } from '../../Common/Alerts/constants';

const VenmoHeader = (): JSX.Element => {
  return (
    <Alert type={ALERT_TYPE.INFO}>
      {getContent('valueProps.payWith.guest.venmo.noApp')}{' '}
      {getContent('valueProps.payWith.guest.venmo.continueWithPaypal')}
    </Alert>
  );
};

export { VenmoHeader };
